import React from 'react';
import { Divider, Typography } from '@mui/material';
import { Accessory } from '@peerless/data-access/cart-service';
import { ProductAccessoryTile } from '../../products/components/ProductAccessoryTile';
import { useTranslations } from 'next-intl';

interface Props {
  data: Accessory[];
}

export const CartSlideoutAccessoryList: React.FC<Props> = ({ data }: Props) => {
  const t = useTranslations();
  return (
    <>
      <Typography variant={'h3'} className="header-underline">
        {t('Product.accessories')}
      </Typography>

      {data.map(item => (
        <React.Fragment key={item.product.sku}>
          <ProductAccessoryTile
            key={item.product.sku}
            product={item.product}
            pricing={item.pricing}
            direction="row"
          />
          <Divider sx={{ borderWidth: '1px', marginBottom: 2, marginTop: 2 }} />
        </React.Fragment>
      ))}
    </>
  );
};
